<template>
    <p class="mb-0">
        <span :class="['main-text', largeMobileValue ? 'large-main-text' : 'small-main-text']">
            {{ amount ?? defaultAmount() }}
        </span>

        <span
            v-if="offer.type === 'line_of_credit' || offer.type === 'credit card only'"
            class="small-text d-flex align-self-start"
        >
            {{ $t('results.creditLimit') }}
        </span>

        <span v-else class="small-text d-flex align-self-start">
            {{ $t('results.amount') }}
        </span>
    </p>
</template>

<script>
import { formatCurrency } from '@js/utilities/number.js'

export default {
    props: {
        amount: {
            type: [Number, String],
        },
        largeMobileValue: {
            type: Boolean,
            default: true,
        },
    },
    inject: ['offer'],
    methods: {
        formatCurrency: formatCurrency,
        defaultAmount: function () {
            return this.formatCurrency(
                !this.offer.loan_amount.min ? this.offer.loan_amount.min : this.offer.loan_amount.formatted,
            )
        },
    },
}
</script>
